import { boot } from 'quasar/wrappers'
import m from 'moment'
import 'moment/locale/it'

const currency = (a?: number) => a ? a.toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : undefined
export default boot(async ({ Vue }) => {
  Vue.filter('currency', currency)
  // Vue.filter('currencyShort', a => { // non usato
  //   if (a > 10 ** 6) return (`${a / (10 ** 6)} M`).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  //   if (a > 10 ** 3) return (`${a / (10 ** 3)} K`).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  //   return currency(a)
  // })
  // Vue.filter('currency', function (value) {
  //   if (typeof value !== 'number') return value
  //   return new Intl.NumberFormat('it', {
  //     style: 'currency',
  //     currency: 'EUR',
  //     minimumFractionDigits: 0
  //   }).format(value)
  // })
  // Vue.filter('short', function (value, digits = 0) {
  //   let i, si = [
  //       { value: 1, symbol: '' },
  //       { value: 1E3, symbol: 'k' },
  //       { value: 1E6, symbol: 'M' },
  //       { value: 1E9, symbol: 'G' },
  //       { value: 1E12, symbol: 'T' },
  //       { value: 1E15, symbol: 'P' },
  //       { value: 1E18, symbol: 'E' }
  //     ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/

  //   for (i = si.length - 1; i > 0; i--) if (value >= si[i].value) break

  //   return (value / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
  // })

  Vue.filter('datetime', (a: string) => m(a).format('dddd D MMMM YYYY, HH:mm'))
  Vue.filter('time', (a: string) => m(a).format('LT'))
  Vue.filter('from', (a: string, b: string) => m(a).from(b, true))
  Vue.filter('human', (a: string, without = false) => m(a).fromNow(without))
  Vue.filter('diff', (a: string, b: string) => {
    if (m(b).diff(a, 'months') > 12) return `${m(b).diff(a, 'years')} anni`
    else if (m(b).diff(a, 'days') > 61) return `${m(b).diff(a, 'months')} mesi`
    else return `${m(b).diff(a, 'days')} giorni`
  })
  Vue.filter('calendar', (a: string) => m(a).calendar(null, {
    sameDay: '[oggi]',
    nextDay: '[domani]',
    // nextWeek: 'dddd prossimo',
    lastDay: '[ieri]',
    // lastWeek: '[lo scorso] dddd',
    // sameElse: 'DD/MM/YYYY'
  }))
  Vue.filter('date', (a: string) => m(a).format('MMMM YYYY'))
  Vue.filter('date2', (a: string) => m(a).format('LL'))
  Vue.filter('date3', (a: string) => m(a).format('L'))
  Vue.filter('date4', (a: string) => m(a).format('DD.MM.YYYY'))
  Vue.filter('date5', (a: string) => m(a).format('DD MMM YYYY'))
  Vue.filter('date6', (a: string) => m(a).format('D/M/YY'))

  // Vue.filter('slashN', (a = '') => a.replace('\r\n', '<br/>'))
  Vue.filter('letters', (a: string | null) => (a || '').split(' ').map(([first = '']) => first.toUpperCase()).join(''))
  Vue.filter('no-caps', (a: string | null) => (a || '').split(' ').map(([first = '', ...rest]) => first.toUpperCase() + rest.map(w => w.toLowerCase()).join('')).join(' '))
})
